import { render, staticRenderFns } from "./buddha-grant.vue?vue&type=template&id=6e4f2df3"
import script from "./buddha-grant.vue?vue&type=script&lang=js"
export * from "./buddha-grant.vue?vue&type=script&lang=js"
import style0 from "./buddha-grant.vue?vue&type=style&index=0&id=6e4f2df3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports